import Vue from 'vue';

let _host = "http://localhost:53100/"

export function setRedPipeApiHost(host){
    _host = host.replace('api/', '');
}

export async function getGameResources(gameId) {
    const url = `${_host}api/resources/games/${gameId}`;
    return (await Vue.http.get(url)).data;    
}

export function getResourcesUrl(){
    const url = `${_host}api/resources/`;
    return url;
}

export async function getStoredGame() {
    const url = `${_host}api/games/`;
    return (await Vue.http.get(url)).data;    
}

export async function getSystemInfo() {
    const url = `${_host}api/sys/info`;
    return (await Vue.http.get(url)).data;    
}



// WEBPACK FOOTER //
// ./skins/xkiosk/services/resources.service.js